import { NinetailedSsrPlugin } from "@ninetailed/experience.js-plugin-ssr";

// Instantiating the plugin at module scope keeps the same instance across
// re-renders so the visitor cookie isn't rewritten on every tree update.
export const ssrPlugin = new NinetailedSsrPlugin();
